export enum AppointCompanyStepsEnum {
  FormDescription = 0,
  CompanyInformation = 1,
  NewAddressInformation = 2,
  // Preview = 4,
  // ReadyToSubmit = 5,
}
